export interface JsonContractAgency {
  numClient?: number;
  name?: string;
  temActif?: string;
}

export class ContractAgency {
  id: number;
  name: string;
  temActif: string;

  constructor(jsonContractAgency: JsonContractAgency = null) {
    this.id = jsonContractAgency.numClient;
    this.name = jsonContractAgency.name;
    this.temActif = jsonContractAgency.temActif;
  }
}
